import { BAND_META } from "./constants";

// Per-country band status for the card: which open bands are waiting on the real country request,
// which came back empty, and what the polite live region should announce.
export function bandStatus({ country, loading, error, loadedResults, bandsOpen }) {
  const open = BAND_META.filter((b) => bandsOpen?.[b.key]);
  if (error) return { pending: [], empty: [], message: `Couldn't load ${country} courses.` };
  if (loading) {
    const names = open.map((b) => b.label).join(" and ");
    return { pending: open.map((b) => b.key), empty: [], message: names ? `Loading ${names} courses…` : "Loading courses…" };
  }
  if (!Array.isArray(loadedResults)) return { pending: [], empty: [], message: "" };
  const counts = {};
  loadedResults.forEach((r) => { const k = r?.classification?.bucket; if (k) counts[k] = (counts[k] || 0) + 1; });
  const empty = open.filter((b) => !counts[b.key]);
  return {
    pending: [],
    empty: empty.map((b) => b.key),
    message: empty.length ? `No ${empty.map((b) => b.label).join(" or ")} courses came back for ${country}.` : "",
  };
}
